export enum StorageE {
  IdToken = 'idToken',
  RefreshToken = 'refreshToken',
  LocationStore = 'locationStore',
  LatestReleaseNoteId = 'latestReleaseNoteId',
  IsLatestReleaseNoteDismissed = 'isLatestReleaseNoteDismissed',
  SavedRoofTops = 'savedRoofTops',
  TicketTabs = 'ticketTabs',
  ScheduleTicketTabs = 'scheduleTicketTabs',
  /** Per-user key prefix: use with userId, e.g. `${StorageE.TicketFilterPreferences}${userId}` */
  TicketFilterPreferences = 'ticketFilterPreferences_',
  /** Per-user key prefix: dealer card dropdown selection (empty = all) */
  DealerCardSelectedRooftopIds = 'dealerCardSelectedRooftopIds_',
  /** Dealer card accordion expanded (mobile) */
  DealerCardExpanded = 'dealerCardExpanded',
  /** Cards row (dealer card, schedule cards, etc.) expanded */
  CardsRowExpanded = 'cardsRowExpanded',
  /** Banner message card horizontally collapsed */
  BannerCardCollapsed = 'bannerCardCollapsed',
  /** Billing periods card horizontally collapsed */
  BillingCardCollapsed = 'billingCardCollapsed',
  /** Schedule cards accordion expanded */
  ScheduleCardsExpanded = 'scheduleCardsExpanded',
  ThemeMode = 'themeMode',
}

/** Increment to invalidate saved filter preferences and reset to defaults */
export const FILTER_PREFERENCES_VERSION = 1;
